import { v4 } from 'uuid';
import { getHomeApiUrl } from '../selectors/getBaseUrlSelectors';
import CLIENT_ID_ONLINE from '../constants/rootConstants';

export default {
  fetch: (id, action, state) => ({
    url: `${getHomeApiUrl(state)}/travel/home/v1/tls/benefits`,
    opts: {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        clientId: CLIENT_ID_ONLINE,
        correlation_id: v4(),
      },
    },
  }),
  transformData: (data) => ({
    accounts: data.accounts,
  }),
};
